import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query unidadMedida {
            TYPES {
              UnidadMedida {
                readAll {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
      })
      .then((result) => result.data.data.TYPES.UnidadMedida.readAll),

  listServicio: () =>
    api
      .send({
        query: gql`
          query unidadMedida {
            TYPES {
              UnidadMedida {
                readServicio {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
      })
      .then((result) => result.data.data.TYPES.UnidadMedida.readServicio),

  listProducto: () =>
    api
      .send({
        query: gql`
          query unidadMedida {
            TYPES {
              UnidadMedida {
                readProducto {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
      })
      .then((result) => result.data.data.TYPES.UnidadMedida.readProducto),
};
